export default __webpack_public_path__ + "static/media/warning.c9bc41c7.svg";